import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    index:0,
    currentQuestion: {},
    choicesList:[
    ],
    tutorielsList:[
    ],
    isGameCompleted:false,
    resultat:{},
}
const tester_niveauSlice = createSlice({
    name:'tester_niveau',
    initialState,
    reducers:{
        setCurrentQuestion_testerNiveau:(state,{payload})=>{
            state.currentQuestion = payload
            state.index = state.index + 5
        },
        setChoicesList_testerNiveau:(state,{payload})=>{
            state.choicesList = payload;
        },
        setTutorielsList_testerNiveau:(state,{payload})=>{
            state.tutorielsList = payload
        },
        setIsGameCompleted_testerNiveau:(state,{payload})=>{
            state.isGameCompleted = true
            state.resultat = payload
        },
        resetGame_testerNiveau:(state,{payload})=>{
            state.isGameCompleted = false
            state.choicesList = []
            state.currentQuestion = {}
            state.index = 0
            state.resultat = {}
        },
    }
})

export const { setCurrentQuestion_testerNiveau,setChoicesList_testerNiveau,
    setIsGameCompleted_testerNiveau ,resetGame_testerNiveau} = tester_niveauSlice.actions
export default tester_niveauSlice.reducer